import React, { useEffect, useState, useRef, useCallback } from "react";
import { Alert, Col, Dropdown, DropdownMenu, DropdownToggle, Label, Modal, ModalBody, ModalHeader, Spinner, Nav, NavItem, NavLink, Row, TabContent, TabPane, FormFeedback, Input } from "reactstrap";
import Select from "react-select";
import { Form, Link } from "react-router-dom";
import classnames from "classnames";
import socketIO from "../../helpers/socket";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { getNotification as onGetNotifications, addNewNotification as onAddNewNotification, updateNotification as onUpdateNotification, deleteNotification as onDeleteNotification, getNotificationLoading, setReadNotification as onSetReadNotification } from "../../store/notification/action";
import PropTypes from "prop-types";
import withRouter from "./withRouter";
import { withTranslation } from "react-i18next";
import sound from "../../assets/notif.mp3";

//SimpleBar
import SimpleBar from "simplebar-react";
import moment from "moment";

import * as Yup from "yup";
import { useFormik } from "formik";
import { getDepartment, resetDepartmentState } from "../../store/department/action";

const Broadcast = (props) => {
  const [modal, setModal] = useState(false);

  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, loading, clients, clientLoading, productVarians, companies, companyLoading, departments, departmentLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    loading: state.Notification.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
  }));

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: "",
      description: "",
      category: "", // KONSUMEN, SALESMAN, SISANYA GET
      company: companySelected,
      client: clientSelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name").nullable(true),
      company: Yup.object().required("Please Enter company").nullable(true),
      category: Yup.object().required("Please Enter Kategori").nullable(true),
    }),
    onSubmit: (values) => {
      const newFormData = {
        name: values.name,
        description: values.description,
        category: values.category.value ?? "", // KONSUMEN, SALESMAN, SISANYA GET
        companyId: values.company.value ?? "",
        clientId: values.client.value ?? "",
      };
      dispatch(onAddNewNotification(newFormData));
      validation.resetForm();
      toggle();
    },
  });

  const handleGetDepartment = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      // setCivilBudget(null);
    } else {
      setModal(true);
    }
  }, [modal, dispatch]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    const staticOpt = [
      { label: "KONSUMEN", value: "KONSUMEN" },
      { label: "SALESMAN", value: "SALESMAN" },
      { label: "SEMUA DEPARTEMEN", value: "SEMUA DEPARTEMEN" },
    ];

    var data = [];
    var opt = [];
    departments.forEach((item, key) => {
      const name = item.name;
      var obj = { label: name, value: name };
      opt.push(obj);
    });
    var option = { options: [...staticOpt, ...opt] };
    data.push(option);

    if (departments.length > 0) {
      setDepartmentList(data);
    }
  }, [departments]);

  return (
    <React.Fragment>
      <button onClick={toggle} type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none">
        <i className="ri-signal-tower-line fs-22"></i>
      </button>
      <Modal id="showModal" isOpen={modal} centered size="lg">
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          Broadcast
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-lg-4">
              <div className="mb-3">
                <Label htmlFor="client-field" className="form-label">
                  Grup Usaha&nbsp;
                  {clientLoading && (
                    <Spinner color="primary" size="sm">
                      Loading...
                    </Spinner>
                  )}
                </Label>
                <Select
                  name="client"
                  value={validation.values.client}
                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                  placeholder="Pilih Grup Usaha"
                  onChange={(e) => {
                    setCompanyList([]);
                    validation.setFieldValue("client", e);
                  }}
                  options={clientList}></Select>
                {validation.touched.client && validation.errors.client && (
                  <small className="text-danger" type="invalid">
                    {validation.errors.client}
                  </small>
                )}
              </div>
              <div className="mb-3">
                <Label htmlFor="company-field" className="form-label">
                  Perusahaan&nbsp;
                  {companyLoading && (
                    <Spinner color="primary" size="sm">
                      Loading...
                    </Spinner>
                  )}
                </Label>
                <Select
                  name="company"
                  value={validation.values.company}
                  placeholder="Pilih Perusahaan"
                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                  onChange={(e) => {
                    setDepartmentList([]);
                    validation.resetForm();
                    validation.setFieldValue("company", e);
                    handleGetDepartment(e.value);
                  }}
                  options={companyList}></Select>
                {validation.touched.company && validation.errors.company && (
                  <small className="text-danger" type="invalid">
                    {validation.errors.company}
                  </small>
                )}
              </div>
              <div className="mb-3">
                <Label htmlFor="category-field" className="form-label">
                  Kirim Kepada&nbsp;
                  {departmentLoading && (
                    <Spinner color="primary" size="sm">
                      Loading...
                    </Spinner>
                  )}
                </Label>
                <Select
                  name="category"
                  value={validation.values.category}
                  placeholder="Kirim Kepada"
                  onChange={(e) => {
                    validation.resetForm();
                    validation.setFieldValue("category", e);
                  }}
                  options={departmentList}></Select>
                {validation.touched.category && validation.errors.category && (
                  <small className="text-danger" type="invalid">
                    {validation.errors.category}
                  </small>
                )}
              </div>
            </div>
            <div className="col-lg-8">
              <div className="mb-3">
                <Label htmlFor="name-field" className="form-label">
                  Judul
                </Label>
                <Input name="name" id="name-field" className="form-control" placeholder="Isi Judul" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
              </div>
              <div className="mb-3">
                <Label htmlFor="des-field" className="form-label">
                  Pesan
                </Label>
                <Input name="description" id="des-field" className="form-control" rows={6} placeholder="Isi Pesan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
              </div>
            </div>
          </div>
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => {
                setModal(false);
              }}>
              Tutup
            </button>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
              className="btn btn-success">
              <span className="d-flex align-items-center">
                <span className="flex-grow-1 me-2">{"Simpan"}</span>
                {loading && (
                  <Spinner size="sm" className="flex-shrink-0" role="status">
                    Loading...
                  </Spinner>
                )}
              </span>
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default Broadcast;
